import React from 'react';
import { Helmet } from 'react-helmet-async';

const AlgemeneVoorwaarden = () => {
  return (
    <div data-testid="terms-page">
      <Helmet>
        <title>Algemene Voorwaarden | Max Q Renovaties</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="bg-[#3a190b] text-white py-12">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-3xl font-bold">Algemene Voorwaarden</h1>
          <p className="text-white/70 mt-2">Laatst bijgewerkt: april 2026</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 prose prose-lg max-w-none prose-headings:text-[#202020]">
          
          <h2>Artikel 1 - Identiteit van de onderneming</h2>
          <p>
            Max Q, powered by Q Technics<br />
            Maatschappelijke zetel: Gerhees 118, 3945 Ham, Belgie<br />
            Ondernemingsnummer: BE 0891.533.928<br />
            Email: info@maxq.be<br />
            Telefoon: +32 488 15 20 28
          </p>

          <h2>Artikel 2 - Toepassingsgebied</h2>
          <p>
            Deze algemene voorwaarden zijn van toepassing op alle offertes, overeenkomsten en leveringen van Max Q, 
            tenzij schriftelijk anders overeengekomen. Door een bestelling te plaatsen of een offerte te aanvaarden, 
            aanvaardt de klant deze algemene voorwaarden.
          </p>
          <p>
            Eventuele afwijkende voorwaarden van de klant zijn slechts geldig indien deze uitdrukkelijk 
            en schriftelijk door Max Q werden aanvaard.
          </p>

          <h2>Artikel 3 - Offertes en prijzen</h2>
          <p>
            3.1. Alle offertes zijn vrijblijvend en geldig gedurende 30 kalenderdagen na datum van uitgifte, 
            tenzij anders vermeld op de offerte.
          </p>
          <p>
            3.2. De opgegeven prijzen zijn exclusief BTW (21%), tenzij uitdrukkelijk anders vermeld. 
            De BTW en eventuele andere heffingen zijn steeds ten laste van de klant.
          </p>
          <p>
            3.3. <strong>Prijsstijgingen:</strong> Indien na het opmaken van de offerte de prijzen van materialen, 
            grondstoffen, lonen of andere kosten stijgen, behoudt Max Q zich het recht voor de overeengekomen 
            prijzen proportioneel aan te passen. De klant wordt hiervan vooraf schriftelijk op de hoogte gebracht. 
            Bij een prijsstijging van meer dan 10% heeft de klant het recht de overeenkomst kosteloos te ontbinden 
            binnen 14 dagen na kennisgeving.
          </p>
          <p>
            3.4. Meerwerken die niet in de oorspronkelijke offerte zijn opgenomen worden afzonderlijk gefactureerd 
            tegen de op dat moment geldende tarieven. Meerwerken worden steeds vooraf besproken met de klant.
          </p>

          <h2>Artikel 4 - Uitvoering van de werken</h2>
          <p>
            4.1. Max Q verbindt zich ertoe de werken uit te voeren als een goed vakman, 
            conform de regels van de kunst en de geldende normen en regelgeving.
          </p>
          <p>
            4.2. De opgegeven uitvoeringstermijnen zijn indicatief en niet bindend, tenzij uitdrukkelijk 
            anders overeengekomen. Vertragingen door overmacht, weersomstandigheden, leveringsproblemen 
            of beslissingen van de klant geven geen recht op schadevergoeding.
          </p>
          <p>
            4.3. De klant zorgt ervoor dat de werkplaats vrij toegankelijk is en dat water en elektriciteit 
            beschikbaar zijn op de werf. Bijkomende kosten door het niet naleven hiervan zijn ten laste van de klant.
          </p>
          <p>
            4.4. De klant verbindt zich ertoe tijdig alle nodige vergunningen aan te vragen die vereist zijn 
            voor de uitvoering van de werken.
          </p>

          <h2>Artikel 5 - Betalingsvoorwaarden</h2>
          <p>
            5.1. De betaling geschiedt als volgt, tenzij anders overeengekomen:
          </p>
          <ul>
            <li><strong>Voorschot:</strong> 30% van het totaalbedrag bij aanvaarding van de offerte</li>
            <li><strong>Tussentijdse facturatie:</strong> volgens vorderingsstaat van de werken</li>
            <li><strong>Eindfactuur:</strong> saldo bij oplevering van de werken</li>
          </ul>
          <p>
            5.2. Alle facturen zijn betaalbaar binnen 14 kalenderdagen na factuurdatum, tenzij anders vermeld.
          </p>
          <p>
            5.3. Bij laattijdige betaling is van rechtswege en zonder ingebrekestelling een verwijlintrest 
            verschuldigd van 1% per maand op het openstaande bedrag. Daarnaast is een forfaitaire 
            schadevergoeding verschuldigd van 10% van het factuurbedrag, met een minimum van 150 euro.
          </p>
          <p>
            5.4. Max Q behoudt zich het recht voor de werken op te schorten bij niet-betaling van een 
            vervallen factuur of voorschotfactuur.
          </p>

          <h2>Artikel 6 - Garantie</h2>
          <p>
            6.1. <strong>Waterdichtheid:</strong> Max Q biedt een garantie van 10 jaar op waterdichtheid 
            van de door ons uitgevoerde werken, mits normaal gebruik en onderhoud.
          </p>
          <p>
            6.2. <strong>Materialen:</strong> Op materialen geldt de fabrieksgarantie zoals voorzien door 
            de betreffende fabrikant, tenzij schriftelijk anders overeengekomen. Max Q kan niet aansprakelijk 
            worden gesteld voor gebreken die te wijten zijn aan de fabrikant.
          </p>
          <p>
            6.3. De garantie vervalt indien:
          </p>
          <ul>
            <li>De werken zijn gewijzigd of hersteld door derden zonder voorafgaande toestemming van Max Q</li>
            <li>De schade het gevolg is van oneigenlijk gebruik, nalatigheid of gebrekkig onderhoud</li>
            <li>De schade het gevolg is van overmacht (waterschade door overstroming, brand, etc.)</li>
            <li>De klant de betalingsverplichtingen niet is nagekomen</li>
          </ul>
          <p>
            6.4. Garantieclaims dienen schriftelijk te worden ingediend bij Max Q via info@maxq.be 
            met een duidelijke beschrijving en foto's van het gebrek.
          </p>

          <h2>Artikel 7 - Klachten</h2>
          <p>
            7.1. Klachten betreffende de uitgevoerde werken dienen binnen 8 kalenderdagen na facturatie 
            schriftelijk gemeld te worden aan Max Q. Na deze termijn worden de werken als aanvaard beschouwd.
          </p>
          <p>
            7.2. Klachten betreffende facturen dienen eveneens binnen 8 kalenderdagen na ontvangst 
            schriftelijk gemeld te worden. Het indienen van een klacht schort de betalingsverplichting niet op.
          </p>
          <p>
            7.3. Zichtbare gebreken die niet werden gemeld bij de (voorlopige) oplevering worden geacht 
            aanvaard te zijn door de klant.
          </p>

          <h2>Artikel 8 - Oplevering</h2>
          <p>
            8.1. Na voltooiing van de werken vindt een oplevering plaats in aanwezigheid van de klant. 
            Eventuele opmerkingen worden genoteerd en binnen een redelijke termijn verholpen.
          </p>
          <p>
            8.2. Indien de klant niet aanwezig is bij de oplevering ondanks een uitnodiging hiertoe, 
            worden de werken geacht aanvaard te zijn.
          </p>

          <h2>Artikel 9 - Aansprakelijkheid</h2>
          <p>
            9.1. De aansprakelijkheid van Max Q is beperkt tot het bedrag van de uitgevoerde werken 
            zoals vermeld in de overeenkomst.
          </p>
          <p>
            9.2. Max Q is niet aansprakelijk voor indirecte schade, gevolgschade of gederfde winst.
          </p>
          <p>
            9.3. Max Q is niet aansprakelijk voor schade aan verborgen leidingen, kabels of constructies 
            waarvan het bestaan niet vooraf door de klant werd meegedeeld.
          </p>

          <h2>Artikel 10 - Overmacht</h2>
          <p>
            In geval van overmacht (waaronder begrepen maar niet beperkt tot: stakingen, epidemieen, 
            pandemie, overheidsmaatregelen, leveringsproblemen, extreme weersomstandigheden) is Max Q 
            gerechtigd de uitvoering van de overeenkomst op te schorten of te ontbinden, 
            zonder dat de klant recht heeft op schadevergoeding.
          </p>

          <h2>Artikel 11 - Eigendomsvoorbehoud</h2>
          <p>
            Alle geleverde materialen en goederen blijven eigendom van Max Q tot volledige betaling 
            van alle verschuldigde bedragen, inclusief intresten en kosten.
          </p>

          <h2>Artikel 12 - Intellectueel eigendom</h2>
          <p>
            Alle ontwerpen, tekeningen en plannen opgemaakt door Max Q blijven eigendom van Max Q 
            en mogen niet zonder schriftelijke toestemming worden gereproduceerd of aan derden worden overgemaakt.
          </p>

          <h2>Artikel 13 - Toepasselijk recht en geschillen</h2>
          <p>
            Op alle overeenkomsten is het Belgisch recht van toepassing. In geval van geschillen 
            zijn uitsluitend de rechtbanken van het gerechtelijk arrondissement Limburg bevoegd.
          </p>

          <h2>Artikel 14 - Slotbepalingen</h2>
          <p>
            14.1. Indien een bepaling van deze voorwaarden nietig of onuitvoerbaar wordt verklaard, 
            blijven de overige bepalingen onverminderd van kracht.
          </p>
          <p>
            14.2. Max Q behoudt zich het recht voor deze algemene voorwaarden te wijzigen. 
            De meest recente versie is steeds beschikbaar op www.maxq.be/algemene-voorwaarden.
          </p>
        </div>
      </section>
    </div>
  );
};

export default AlgemeneVoorwaarden;
